import { render, staticRenderFns } from "./FileShareAvatar.vue?vue&type=template&id=c7090b46"
import script from "./FileShareAvatar.vue?vue&type=script&lang=js"
export * from "./FileShareAvatar.vue?vue&type=script&lang=js"
import style0 from "./FileShareAvatar.vue?vue&type=style&index=0&id=c7090b46&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports